import { Modal, Button } from "antd";

// Окно для выбора фильтров
const FiltersModal = ({
  children,
  visible,
  onSave,
  onCancel,
  onClear,
  width = 600,
}) => {
  return (
    <Modal
      maskClosable={false}
      title="Фильтры"
      open={visible}
      width={width}
      onCancel={onCancel}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button onClick={onClear} style={{ marginRight: "auto" }}>
            Сбросить
          </Button>

          <Button key="back" onClick={onCancel}>
            Отмена
          </Button>

          <Button key="submit" type="primary" onClick={onSave}>
            Подобрать
          </Button>
        </div>
      }
    >
      {children}
    </Modal>
  );
};

export default FiltersModal;
